import { FONTS, COLORS } from '../../../constants';

const styles = {
  errMsg: {
    color: COLORS.RED,
    fontFamily: FONTS.PRIMARY,
    fontWeight: 300,
    fontSize: '0.875rem',
  },
};

export default styles;
